import React, { useEffect, useState } from "react";
import axios from "../../axiosinstens";
import Layouts from "../../Components/Layouts/Layouts";
import "bootstrap/dist/css/bootstrap.min.css";
import { environment } from "../../environment";
import { FaFilePdf, FaDownload, FaEye } from "react-icons/fa";
import { Helmet } from "react-helmet-async";

function AllDownloads() {
  const [downloads, setDownloads] = useState([]);

  useEffect(() => {
    getDownloads();
  }, []);

  const getDownloads = async () => {
    try {
      const response = await axios.get("getAllDownloads");
      setDownloads(response.data.downloads);
    } catch (error) {
      console.error(error);
    }
  };

  const getFileUrl = (file) => `${environment.imageBaseURL}download/${file}`;

  const handleView = (file) => {
    window.open(getFileUrl(file), "_blank", "noopener,noreferrer");
  };

  const handleDownload = (file, fileName) => {
    const link = document.createElement("a");
    link.href = getFileUrl(file);
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const isPdf = (file) => file.toLowerCase().endsWith(".pdf");

  return (
    <>
      <Helmet>
        <title>
          Resources | Martial Arts Training Downloads & Educational Materials
        </title>

        <meta
          name="description"
          content="Access free martial arts resources, downloadable training materials, seminar guides, instructor tools, and educational content to support your martial arts journey and professional development."
        />

        <meta
          name="keywords"
          content="martial arts resources, martial arts downloads, training materials, seminar resources, martial arts guides, instructor resources, karate training downloads, taekwondo materials, MMA resources, self defense guides"
        />
      </Helmet>
      <Layouts>
        <div className="container mt-5">
          <h2 style={{ textAlign: "center" }}>All Resources</h2>
          <hr />

          <div className="row">
            {downloads.map((item) => (
              <div className="col-md-4 mb-4" key={item._id}>
                <div
                  className="card shadow rounded p-3 text-center"
                  style={{ minHeight: "300px" }}
                >
                  {/* Preview */}
                  <div style={{ height: "120px" }}>
                    {isPdf(item.file) ? (
                      <FaFilePdf size={90} className="text-danger" />
                    ) : (
                      <img
                        src={getFileUrl(item.file)}
                        alt={item.name}
                        style={{
                          height: "100px",
                          maxWidth: "100%",
                          objectFit: "contain",
                        }}
                      />
                    )}
                  </div>

                  {/* Title */}
                  <h4 className="mt-3">{item.name}</h4>

                  {/* Description */}
                  <p className="text-muted">
                    {item.description || "Download file"}
                  </p>

                  {/* Buttons */}
                  <div className="d-flex justify-content-between mt-auto">
                    <button
                      className="btn btn-outline-dark w-50 me-2"
                      onClick={() => handleView(item.file)}
                    >
                      <FaEye /> View Online
                    </button>

                    <button
                      className="btn btn-dark w-50"
                      onClick={() => handleDownload(item.file, item.file_name)}
                    >
                      <FaDownload /> Download
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
          {downloads.length === 0 && (
            <>
              <div
                className="d-flex justify-content-center align-items-center mt-auto w-100"
                style={{ minHeight: "400px" }}
              >
                <img
                  src="flat-design-no-data.png"
                  alt="No Resources"
                  style={{
                    height: "400px",
                    objectFit: "contain",
                    cursor: "not-allowed",
                  }}
                />
              </div>
              <div className="text-center mt-3">
                <h2>No Resources Available</h2>
              </div>
            </>
          )}
        </div>
      </Layouts>
    </>
  );
}

export default AllDownloads;
